import React from 'react';
import { LaptopIcon } from './Icons';

// Shown to phones (see utils/deviceDetection); tablets and computers can take the test
export function DesktopRequired({ children }: { children?: React.ReactNode }) {
  return (
    <div className="desktop-required">
      <div className="icon-badge">
        <LaptopIcon size={30} />
      </div>
      <h2>Desktop Required</h2>
      <p>
        This assessment is designed to evaluate keyboard typing skills and must be completed on a desktop or laptop
        computer. Please return to this page on a computer to continue.
      </p>
      {children}
    </div>
  );
}
